import {
    PRODUCT_SPECIFICATIONS_GET_ERROR,
    PRODUCT_SPECIFICATIONS_GET_SUCCESS,
} from '../actionTypes/ProductSpecificationsActionTypes';

function ProductSpecificationsReducer(state = [], action) {
    switch (action.type) {
        case PRODUCT_SPECIFICATIONS_GET_ERROR:
            return [{ error: action.payload.specifications }] || state;
        case PRODUCT_SPECIFICATIONS_GET_SUCCESS:
            return action.payload.specifications || state;
        default:
            return state;
    }
}

export default ProductSpecificationsReducer;
